import Phaser from "phaser";
import { PALETTE, PALETTE_NUM } from "../themes/palette.js";
import { FONT_FAMILY, TYPO } from "./uiTokens.js";

export const ACCOUNT_WARNING_ORANGE = PALETTE_NUM.accentGold;

export function createAccountWarningBadge(
  scene: Phaser.Scene,
  x: number,
  y: number,
  opts: { readonly size?: number; readonly depth?: number } = {},
): Phaser.GameObjects.Container {
  const size = opts.size ?? 14;
  const radius = size / 2;
  const badge = scene.add.container(x, y);
  const bg = scene.add.graphics();
  bg.fillStyle(PALETTE_NUM.accentGold, 1);
  bg.fillCircle(0, 0, radius);
  bg.lineStyle(1, PALETTE_NUM.textBright, 0.85);
  bg.strokeCircle(0, 0, radius - 0.5);
  const mark = scene.add
    .text(0, -0.5, "!", {
      fontFamily: FONT_FAMILY,
      fontSize: TYPO.caption,
      fontStyle: "bold",
      color: PALETTE.textOutline,
    })
    .setOrigin(0.5);
  badge.add([bg, mark]);
  if (opts.depth !== undefined) badge.setDepth(opts.depth);
  return badge;
}
